









import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../system/mixins";
import DocumentPageSelector from "../../DocumentPageSelector.vue";

@Component({
  components: {
    DocumentPageSelector,
  }
})
export default class PageListTool extends Mixins(ModelEditableMixin) {
  @Prop()
  width: number;

  @Prop()
  indicatorFontSize: number;
}
